import React from 'react';
import './Testimonials.css'





const Testimonials = () => {
    return ( 


    <>

<section id="testimonials" className="testimonials">
  <div class="container">
    <div class="row text-center text-white">
      <h1 class="display-3 fw-bold" style={{color: "#fff", fontWeight: "700"}} data-aos="fade-up">Testimonials</h1>
      <hr style={{width: "100px", height: "3px"}} class="mx-auto"/>
      <p class="lead pt-1 p" style={{color: "#fff", fontWeight: "300"}} data-aos="fade-up" data-aos-delay="50">what our students are saying</p>
    </div>

    
    <div class="row align-items-center">
      <div id="carouselExampleCaptions" className="carousel slide" data-bs-ride="carousel" data-aos="fade-up" data-aos-delay="150">
        <div class="carousel-inner">
        
          <div class="carousel-item active">
            
            <div class="testimonials__card">
              <p class="lh-lg p">
                <i class="fas fa-quote-left"></i>
                Lorem ipsum dolor sit amet consectetur adipisicing elit. 
                Placeat aut consequatur illo animi optio exercitationem doloribus eligendi iusto atque repudiandae. Distinctio.
                <i class="fas fa-quote-right"></i>
                <div class="ratings p-1">
                  <i class="fas fa-star"></i>
                  <i class="fas fa-star"></i>
                  <i class="fas fa-star"></i>
                  <i class="fas fa-star"></i>
                  <i class="fas fa-star"></i>
                </div>
              </p>
            </div>
            
            <div class="testimonials__picture">
              <img src={"images/testimonials/client-1.jpg"} alt="" class="rounded-circle img-fluid"/>
            </div>
            
            <div class="testimonials__name">
              <h3 className='h3'>Patrick Muriungi</h3>
              <p class="fw-light p">CEO & founder</p>
            </div>
          </div>     
          
          <div class="carousel-item">
            
            <div class="testimonials__card">
              <p class="lh-lg p">
                <i class="fas fa-quote-left"></i>
                Lorem ipsum dolor sit amet consectetur adipisicing elit. 
                Placeat aut consequatur illo animi optio exercitationem doloribus eligendi iusto atque repudiandae. Distinctio.
                <i class="fas fa-quote-right"></i>
                <div class="ratings p-1">
                  <i class="fas fa-star"></i>
                  <i class="fas fa-star"></i>
                  <i class="fas fa-star"></i>
                  <i class="fas fa-star"></i>
                  <i class="fas fa-star"></i>
                </div>
              </p>
            </div>
            
            <div class="testimonials__picture">
              <img src={"images/testimonials/client-2.jpg"} alt="" className="rounded-circle img-fluid"/>
            </div>
            
            <div class="testimonials__name">
              <h3 className='h3'>Joy Marete</h3>
              <p class="fw-light p">Finance Manager</p>
            </div>
          </div>     
          
          <div class="carousel-item">
            
            <div class="testimonials__card">
              <p class="lh-lg p">
                <i class="fas fa-quote-left"></i>
                Lorem ipsum dolor sit amet consectetur adipisicing elit. 
                Placeat aut consequatur illo animi optio exercitationem doloribus eligendi iusto atque repudiandae. Distinctio.
                <i class="fas fa-quote-right"></i>
                <div class="ratings p-1">
                  <i class="fas fa-star"></i>
                  <i class="fas fa-star"></i>
                  <i class="fas fa-star"></i>
                  <i class="fas fa-star"></i>
                  <i class="fas fa-star"></i>
                </div>
              </p>
            </div>
            
            <div class="testimonials__picture">
              <img src={"images/testimonials/client-3.jpg"} alt="" class="rounded-circle img-fluid"/>
            </div>
            
            <div class="testimonials__name">
              <h3 className='h3'>ClaireBelle Zawadi</h3>
              <p class="fw-light p">Global brand manager</p>
            </div>
          </div>     
          
          <div class="carousel-item">
            
            <div class="testimonials__card">
              <p class="lh-lg p">
                <i class="fas fa-quote-left"></i>
                Lorem ipsum dolor sit amet consectetur adipisicing elit. 
                Placeat aut consequatur illo animi optio exercitationem doloribus eligendi iusto atque repudiandae. Distinctio.
                <i class="fas fa-quote-right"></i>
                <div class="ratings p-1">
                  <i class="fas fa-star"></i>
                  <i class="fas fa-star"></i>
                  <i class="fas fa-star"></i>
                  <i class="fas fa-star"></i>
                  <i class="fas fa-star"></i>
                </div>
              </p>
            </div>
            
            <div class="testimonials__picture">
              <img src={"images/testimonials/client-4.jpg"} alt="" class="rounded-circle img-fluid"/>
            </div>
            
            <div class="testimonials__name">
              <h3 className='h3'>Uhuru Kenyatta</h3>
              <p class="fw-light p">C.E.O & Founder</p>
            </div>
          </div>     
        </div>
        <div class="text-center">
          <button class="btn btn-outline-light fas fa-long-arrow-alt-left" type="button" data-bs-target="#carouselExampleCaptions" data-bs-slide="prev">
        </button>
        <button class="btn btn-outline-light fas fa-long-arrow-alt-right" type="button" data-bs-target="#carouselExampleCaptions" data-bs-slide="next">
        </button>
        </div>
      </div>
    </div>
  </div>
</section>
    
    </> 


    );
}
 
export default Testimonials;